import { mdiShieldKeyOutline } from '@mdi/js'
import Icon from '@mdi/react'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { Flex } from '@/components/ui/flex'
import { Text } from '@/components/ui/typography'
import useColorModeValue from '@/hooks/useColorModeValue'

export const Loading = () => {
    const { t } = useTranslation()

    useEffect(() => {
        localStorage.setItem('showWizzard', 'true')
    })

    return (
        <Flex direction="column" alignItems="center" justifyContent="center" flex="1">
            <Icon
                path={mdiShieldKeyOutline}
                size="52px"
                color={useColorModeValue('var(--chakra-colors-blue-700)', 'var(--chakra-colors-blue-300)')}
            />
            <Text fontSize="50px" fontWeight="bold" py="16px" lineHeight="80px">
                {t('global.loading.authenticationInProgress')}
            </Text>
            <Text textAlign="center">{t('global.loading.standBy')}</Text>
        </Flex>
    )
}
